<ng-container>
  <p class="chip chip-{{ size }} chip-{{ color }}">
    {{ formatValue(value) || 'common.na' | translate }}
  </p>
</ng-container>
